<template>
    <div class="pagebox">
        <img src="@/assets/spring/dw_7.png" class="logo" alt="">
        <img src="@/assets/spring/dw_5.png" class="ctimg" alt="">
        <div class="rulesct">
            <p class="rulesp">1.仅限中国大陆用户使用，兑换聚瑞指定商品;</p>
            <p class="rulesp">2.兑换时间：2026 年 6 月 5 日 - 6 月 15 日;</p>
            <p class="rulesp">3.兑换无需额外付费，问题可联系客服</p>
            <img src="@/assets/spring/dw_2.png" class="abtitle" alt="">
            <img src="@/assets/spring/dw_6.png" class="abzz" alt="">
        </div>
        <img src="@/assets/spring/dw_3.png" class="lpqd" alt="">
        <div class="formbox">
            <img src="@/assets/spring/dw_4.png" class="lqdh" alt="">
            <van-form @submit="onSubmit" @failed="failed" class="form" v-if="shows">
                <van-field v-model="cardNo" :label-width="0" name="cardNo" :border="false" label=""
                    placeholder="请输入礼券号码" input-align="left" :rules="[{ required: true }]">
                    <template #label>
                        <div class="labelvant">礼券号码</div>
                    </template>
                </van-field>
                <van-field v-model="cardPwd" name="cardPwd" label="礼券密码" placeholder="请输入礼券密码" input-align="left"
                    :rules="[{ required: true }]">
                    <template #label>
                        <div class="labelvant">礼券密码</div>
                    </template>
                </van-field>
                <van-field :center="true" v-model="verCode" name="verCode" placeholder="请输入验证码" label="验证码"
                    input-align="left" :rules="[{ required: true }]">
                    <template #label>
                        <div class="labelvant">验证码</div>
                    </template>
                    <template #button>
                        <img :src="codeSrc" class="codeimg" @click="getVerifyCode" />
                    </template>
                </van-field>
                <div style="margin: 16px">
                    <van-button round block type="primary" native-type="submit">下一步</van-button>
                </div>
            </van-form>
            <van-form @submit="onSubmit2" class="form" v-if="!shows">
                <!-- <div class="title">设置服务信息</div> -->
                <van-field v-model="receiver" :border="false" name="receiver" label="收货人" placeholder="请输入收货人"
                    input-align="left" :rules="[{ required: true }]">
                    <template #label>
                        <div class="labelvant">收货人</div>
                    </template>
                </van-field>
                <van-field v-model="mobile" name="mobile" label="手机号" placeholder="请输入手机号码" input-align="left"
                    type="tel"
                    :rules="[{ required: true, pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ }]">
                    <template #label>
                        <div class="labelvant">手机号</div>
                    </template>
                </van-field>
                <van-field v-model="fieldValue" name="fieldValue" right-icon="location-o" label="地区" placeholder="请选择所在地区"
                    @click="addressShow = true">
                    <template #label>
                        <div class="labelvant">地区</div>
                    </template>
                </van-field>
                <van-popup v-model="addressShow" round position="bottom">
                    <van-cascader :field-names="fieldNames" v-model="cascaderValue" title="请选择所在地区" :options="options"
                        @close="addressShow = false" @finish="onFinish" />
                </van-popup>
                <van-field class="fieldaddress" v-model="address" name="address" type="textarea" :rows="2" label="收货地址" placeholder="请输入收货地址" input-align="left"
                    :rules="[{ required: true }]">
                    <template #label>
                        <div class="labelvant">收货地址</div>
                    </template>
                </van-field>
                <div style="margin: 16px">
                    <van-button round block type="primary" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>
        <img src="@/assets/spring/dw_1.png" class="btlogo" alt="">
        <van-overlay :show="show" @click="show = false" class-name="bgs">
            <div class="wrapper">
                <div class="tip">
                    <span>恭喜您！兑换成功！礼品将于7个工作日内邮寄，请留意快递信息！</span>
                    <div class="btsize">
                        <van-button round block type="primary" size="small" @click="show = false">确认</van-button>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { getCode, exchange, setShipAddress, getGiftList, getCityCascader } from '@/api/springFestival'
export default {
    name: "LoongBoatFestival",
    data() {
        return {
            title: "端午礼品兑换",
            cardNo: '',
            cardPwd: '',
            verCode: '',
            codeSrc: '',
            uuid: '',
            shows: true,
            show: false,
            receiver: '',
            mobile: '',
            fieldValue: '',
            address: '',
            options: [],
            addressShow: false,
            giftType: '',
            cascaderValue: '',
            pro: { 聚瑞礼包: 'mooncake.png' },
            fieldNames: {
                text: 'label',
                value: 'label',
                children: 'children'
            },
        }
    },
    created() {
        this.getVerifyCode()
        getGiftList({ type: 12 }).then(res => {
            if (res.success) {
                this.giftList = res.content.map(it => {
                    return { ...it, img: this.pro[it.name] }
                })
                this.giftType = this.giftList[0].id
                console.log(this.giftType)
            }
        })
        getCityCascader().then(res => {
            this.options = this.delChildren(res.content)
            console.log(this.options, 'getCityCascader')
        })
        this.show = false
    },
    methods: {
        // 遍历去掉children为空的数据
        delChildren(arr) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].children.length === 0 || arr[i].children === null) {
                    arr[i].children = undefined
                } else {
                    this.delChildren(arr[i].children)
                }
            }
            return arr
        },
        onSubmit(values) {
            const params = {
                cardNo: values.cardNo,
                cardPwd: values.cardPwd,
                verCode: values.verCode,
                uuid: this.uuid,
                giftType: this.giftType, // 礼品类型
                type: 12 // 活动类型
            }
            exchange(params).then(res => {
                if (res.success) {
                    this.shows = false
                } else {
                    this.$toast.fail(res.respMag)
                    this.getVerifyCode()
                    this.cardNo = ''
                    this.cardPwd = ''
                    this.receiver = ''
                    this.address = ''
                    this.mobile = ''
                    this.cascaderValue = ''
                    this.fieldValue = ''
                }
            })
        },
        // 验证不通过
        failed(value) {
            console.log(value)
            this.getVerifyCode()
        },
        getVerifyCode() {
            getCode().then(res => {
                this.codeSrc = res.content.code
                this.uuid = res.content.uuid
                this.verCode = ''
            })
        },
        onFinish({ selectedOptions }) {
            this.addressShow = false
            this.fieldValue = selectedOptions.map(option => option.label).join('/')
        },
        onSubmit2(values) {
            const params = { cardNo: this.cardNo, type: 12, ...values }
            params.province = values.fieldValue.split('/')[0]
            params.city = values.fieldValue.split('/')[1]
            params.area = values.fieldValue.split('/')[2]
            delete params.fieldValue
            setShipAddress(params).then(res => {
                if (res.success) {
                    this.getVerifyCode()
                    this.cardNo = ''
                    this.cardPwd = ''
                    this.receiver = ''
                    this.address = ''
                    this.mobile = ''
                    this.cascaderValue = ''
                    this.fieldValue = ''
                    this.shows = true
                    this.show = true
                } else {
                    this.$toast.success(res.respMag)
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
.labelvant {
    font-weight: 500;
    font-size: 16px;
    color: #0B7151;
    line-height: 30px;
}

.pagebox {
    width: 100%;
    min-height: 100vh;
    padding: 23px 15px 23px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("../../../assets/spring/dwbg.png");
    background-size: 100% 100%;
}

.bgs {
    background-color: rgba(214, 206, 206, 0.7);
}

.wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding-bottom: 50px;
}

.tip {
    width: 300px;
    /* height: 150px; */
    border-radius: 15px;
    padding: 20px 20px 20px 20px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    justify-content: space-between;
}

.btsize {
    width: 150px;
    /* height: 20px; */
}

.tip span {
    line-height: 30px;
}

.codeimg {
    height: 25px;
}

.logo {
    width: 263px;
    height: 19px;
    margin-bottom: 18px;
}

.ctimg {
    width: 100%;
    height: auto;
    margin-bottom: 40px;
}

.rulesct {
    width: 100%;
    min-height: 91px;
    background: linear-gradient(0deg, #FFFFFF, #FAFBCA);
    border-radius: 13px;
    border: 2px solid #2C8B6D;
    position: relative;
    box-sizing: border-box;
    padding: 29px 0 20px 15px;
    margin-bottom: 29px;
}

.rulesp {
    font-size: 12px;
    color: #333333;
    line-height: 22px;
}

.abtitle {
    width: auto;
    height: 36px;
    position: absolute;
    transform: translate(-50%, 0);
    left: 50%;
    top: -18px;
}

.abzz {
    position: absolute;
    width: 50px;
    height: 50px;
    right: -5px;
    top: -20px;
}

.lpqd {
    width: 100%;
    height: auto;
    margin-bottom: 41px;
}

.formbox {
    width: 100%;
    min-height: 275px;
    background: linear-gradient(0deg, #FFFFFF, #FAFBCA);
    border-radius: 13px;
    border: 2px solid #2C8B6D;
    position: relative;
    box-sizing: border-box;
    padding: 40px 10px 27px 10px;
    margin-bottom: 23px;
}

.lqdh {
    position: absolute;
    width: auto;
    height: 36px;
    transform: translate(-50%, 0);
    left: 50%;
    top: -18px;
}

.btlogo {
    width: 262px;
    height: 54px;
}

/deep/ .van-cell {
    background: none !important;
    // width: 100px;
}

/deep/ .van-field__value {
    height: 33px;
    border-radius: 8px;
    border: 1px solid #2C8B6D;
    background: #fff;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    align-items: center;
}
/deep/ .van-field__label{
    margin-right: 0 !important;
}
.fieldaddress /deep/ .van-field__value {
    height: auto !important;
    padding: 5px 10px;
    // align-items: flex-start;
    // padding: 10px;
}
/deep/ .van-field__body{
    width: 100%;
    // height: 100%;
}
</style>
